import { makeObservable, observable, action } from 'mobx';

class pageStore {
  isLoading = true;

  scrollData = {};

  panelData = {};

  tableIndex = '';

  cardIndex = '';

  action = '';

  searchKeyword = '';

  statusObj = {};

  projectList = [];

  url_params = {
    project_ids: [],
    project_version_ids: [],
    uploaded_file_ids: [],
  };

  isSelecatbleWithNavibar = false;

  selectedIndexWithNavibar = {
    project: [],
    project_version: [],
  };

  isUpdateFromTree = false;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      scrollData: observable,
      panelData: observable,
      tableIndex: observable,
      cardIndex: observable,
      action: observable,
      searchKeyword: observable,
      statusObj: observable,
      projectList: observable,
      url_params: observable,
      isSelecatbleWithNavibar: observable,
      isUpdateFromTree: observable,
      setScrollData: action,
      initScrollData: action,
      setStatusData: action,
      initStatusData: action,
      setPanelData: action,
      setAction: action,
      setProjectList: action,
      initProjectList: action,
      setURLparamsWithUploadedFiles: action,
      setSelecteModeValue: action,
      setSelectedIndexValue: action,
      initSelectedIndexValue: action,
      setUpdateValueFromTree: action
    });
  }

  setScrollData = (pathname, pageYOffset, currentPage, pageSize) => {
    if (!this.scrollData[pathname]) {
      this.scrollData = { ...this.scrollData, [pathname]: { offset: pageYOffset, currentPage, pageSize } };
    } else {
      this.scrollData[pathname] = { offset: pageYOffset, currentPage, pageSize };
    }
  };

  initScrollData = (pathname) => {
    if (this.scrollData[pathname]) {
      delete this.scrollData[pathname];
    }
  };

  setStatusData = (value) => {
    this.statusObj = value;
  };

  initStatusData = (type) => {
    const currentObj = this.statusObj;
    switch (type) {
    case 'sort':
      currentObj.sortColumn = 'uploaded';
      break;
    case 'search':
      currentObj.searchKeyword = '';
      break;
    case 'filter':
      currentObj.filter = [];
      break;
    case 'radio':
      currentObj.radioValue = 'udtime_any';
      break;
    case 'files':
      currentObj.uploadedFiles = [];
      break;
    case 'index':
      currentObj.activeIndex = [];
      break;
    default:
      this.statusObj = {};
      break;
    }
  };

  setPanelData = (pathname, pageYOffset, currentPage, tableIndex, cardIndex) => {
    this.panelData = { ...this.panelData, [pathname]: { offset: pageYOffset, currentPage } };
    this.tableIndex = tableIndex;
    this.cardIndex = cardIndex;
  };

  setAction = (value) => {
    this.action = value;
  };

  setURLparams = (obj) => {
    this.url_params = {
      project_ids: obj.project_ids,
      project_version_ids: obj.project_version_ids,
      uploaded_file_ids: obj.uploaded_file_ids,
    };
  };

  setURLparamsWithUploadedFiles = (array) => {
    this.url_params.uploaded_file_ids = array;
  };

  initURLparams = () => {
    this.url_params = {
      project_ids: [],
      project_version_ids: [],
      uploaded_file_ids: [],
    };
  };

  setProjectList = (array) => {
    this.projectList = array;
  };

  initProjectList = () => {
    this.projectList = [];
  };

  setSelecteModeValue = (value) => {
    this.isSelecatbleWithNavibar = value;
  };

  setSelectedIndexValue = (value) => {
    this.selectedIndexWithNavibar = value;
  };

  initSelectedIndexValue = () => {
    this.selectedIndexWithNavibar = {
      project: [],
      project_version: [],
    };
  };

  setUpdateValueFromTree = (value) => {
    this.isUpdateFromTree = value;
  };
}

export default pageStore;
